
import { useEffect } from 'react';
import { LandingNav } from "@/components/landing/LandingNav";
import { SEO } from "@/components/SEO";
import { LandingHero } from "@/components/landing/LandingHero";
import { LandingProblem, LandingSolution, LandingHowItWorks } from "@/components/landing/LandingFeatures";
import { LandingProduct } from "@/components/landing/LandingProduct";
import { LandingPricing } from "@/components/landing/LandingPricing";
import { LandingTestimonials } from "@/components/landing/LandingTestimonials";
import { LandingCTA } from "@/components/landing/LandingCTA";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { LandingVideo } from "@/components/landing/LandingVideo";

const Index = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-software-app';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "RaffleKit",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "description": "Viral giveaway and sweepstakes platform with referral tracking, fraud protection, and winner selection.",
      "url": "https://rafflekit.app",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "description": "Free plan available"
      },
      "featureList": [
        "Viral referral tracking",
        "Fraud and abuse protection",
        "Weighted winner selection",
        "Custom branding",
        "Analytics dashboard",
        "CSV export"
      ]
    });

    // Remove existing if present
    const existing = document.getElementById('schema-software-app');
    if (existing) existing.remove();

    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-software-app');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <SEO
        title="RaffleKit — Free Online Giveaway & Sweepstakes Platform"
        description="Run viral giveaways and sweepstakes in minutes. Built-in referral tracking, fraud protection, and winner selection. Free to start."
        canonical="https://rafflekit.app"
      />
      <LandingNav />
      {/* Hero Section */}
      <LandingHero />

      {/* Video Demo Section */}
      <LandingVideo />

      {/* Problem Section */}
      <LandingProblem />

      {/* Solution Section */}
      <LandingSolution />

      {/* Product Preview Section */}
      <LandingProduct />

      {/* How It Works Section */}
      <LandingHowItWorks />

      {/* Pricing Section */}
      <LandingPricing />

      {/* Testimonials (placeholder) */}
      <LandingTestimonials />

      {/* Final CTA */}
      <LandingCTA />

      {/* Footer */}
      <LandingFooter />
    </div>
  );
};

export default Index;
